import { DialogService } from '@farris/ui-dialog';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridComponent } from '@progress/kendo-angular-grid';
import { FarrisCommonModule } from '@farris/ui-common';
import {
  KendoGridBindingDirective,
  FarrisTreeTableBindingDirective,
  LookupDataMappingDirective,
  LookupEnableExtendLoadMethodDirective,
  UIStateBindingDirective,
  FarrisDisabledDirective,
  FarrisDynamicColumnFormatDirective,
  FarrisEditEnterDirective,
  FarrisTextareaEditDirective,
  FarrisSortDirective,
  FarrisTreeTableFormatDirective,
  GridColumnAggregateDirective,
  GridSummaryDirective,
  FarrisDatagridUseBindingDataDirective,
  MultiSelectDataMappingDirective,
  FarrisListViewBindingDirective,
  EditableDirective,
  InputEndEditDirective,
  FarrisDataGridEndEditDirective,
  HtmlEditorEndEditDirective,
  KendoGridEndEditDirective,
  FarrisDataGridRemoteSummaryDirective,
  FarrisFilePreviewBindingDirective,
  FarrisSetFocusDirective,
  FarrisDiscussionEditorBindingDirective,
  FarrisDiscussionListBindingDirective,
  FarrisPrimengTreeTableBindingDirective,
  FarrisDynamicRequiredDirective,
  FarrisEditorDirective,
  FarrisQuerySolutionEventBindDirective,
  FarrisDateLocalizationDirective,
  FarrisNumberLocalizationDirective,
  FarrisTimeLocalizationDirective,
  FarrisTextLocalizationDirective,
  FarrisCheckboxModificationDirective,
  FarrisLabelModificationDirective,
  FarrisLookupBindingDirective,
  ListNavComponentRefDirective,
  ListViewComponentRefDirective,
  ListFilterComponentRefDirective,
  ViewChangeComponentRefDirective,
  FilterComponentRefDirective,
  SectionComponentRefDirective,
  HtmlEditorComponentRefDirective,
  InputGroupComponentRefDirective,
  DatepickerComponentRefDirective,
  TimePickerComponentRefDirective,
  NumberSpinnerComponentRefDirective,
  ComboListComponentRefDirective,
  ComboLookupComponentRefDirective,
  LookupGridComponentRefDirective,
  DatagridComponentRefDirective,
  TreetableComponentRefDirective,
  WizardComponentRefDirective,
  DiscussionEditorComponentRefDirective,
  DiscussionListComponentRefDirective,
  NavComponentRefDirective,
  MultiSelectComponentRefDirective,
  ScrollspyComponentRefDirective,
  ComboLookupDataMappingDirective,
  AppointmentCalendarBindingDirective,
  CustomDatagridSizeDirective,
  FarrisFilterBindingDirective,
  FarrisListFilterBindingDirective,
  PortletFilterBindingDirective
} from './directives/index';
import {
  FarrisKendoGridFormatService, FarrisTreetableFormatService, StringToDatePipe,
  DateFormatPlaceholderPipe, KendoGridFilterDirective, FormatTotalPipe
} from './format/index';
import {
  ImageIdToUrlPipe,
  FormatPrimeNgTreeTableCellData,
  Localization,
  ElementReadonlyPipe,
  ElementVisibilityPipe,
  ElementRequiredPipe,
  ToolbarUsabilityPipe,
  ToolbarVisibilityPipe,
  ButtonUsabilityPipe,
  ButtonVisibilityPipe,
  AttachmentUploadVisiblePipe,
  AttachmentUploadDisabledPipe,
  AttachmentPreviewVisiblePipe,
  AttachmentPreviewReadonlyPipe,
  AttachmentDisabledPipe,
  AttachmentNoDownloadPipe,
  AttachmentNoPreviewPipe,
  AttachmentPreviewShowCommentsPipe,
  AttachmentPreviewEnableEditFilePipe,
  AttachmentNoDeletePipe
} from './pipes/index';

@NgModule({
  imports: [
    CommonModule,
    FarrisCommonModule.forRoot()
  ],
  declarations: [
    KendoGridBindingDirective,
    FarrisTreeTableBindingDirective,
    LookupDataMappingDirective,
    LookupEnableExtendLoadMethodDirective,
    UIStateBindingDirective,
    FarrisDisabledDirective,
    FarrisSortDirective,
    FarrisDynamicColumnFormatDirective,
    FarrisEditEnterDirective,
    FarrisTextareaEditDirective,
    FarrisTreeTableFormatDirective,
    StringToDatePipe,
    GridColumnAggregateDirective,
    GridSummaryDirective,
    DateFormatPlaceholderPipe,
    ImageIdToUrlPipe,
    FormatPrimeNgTreeTableCellData,
    FarrisDatagridUseBindingDataDirective,
    MultiSelectDataMappingDirective,
    FarrisListViewBindingDirective,
    EditableDirective,
    KendoGridFilterDirective,
    FormatTotalPipe,
    InputEndEditDirective,
    FarrisDataGridEndEditDirective,
    HtmlEditorEndEditDirective,
    KendoGridEndEditDirective,
    FarrisDataGridRemoteSummaryDirective,
    FarrisFilePreviewBindingDirective,
    FarrisSetFocusDirective,
    FarrisDiscussionEditorBindingDirective,
    FarrisDiscussionListBindingDirective,
    FarrisPrimengTreeTableBindingDirective,
    FarrisDynamicRequiredDirective,
    FarrisEditorDirective,
    FarrisQuerySolutionEventBindDirective,
    FarrisDateLocalizationDirective,
    FarrisNumberLocalizationDirective,
    FarrisTimeLocalizationDirective,
    FarrisTextLocalizationDirective,
    Localization,
    FarrisCheckboxModificationDirective,
    FarrisLabelModificationDirective,
    FarrisLookupBindingDirective,
    ListNavComponentRefDirective,
    ListViewComponentRefDirective,
    ListFilterComponentRefDirective,
    ViewChangeComponentRefDirective,
    FilterComponentRefDirective,
    SectionComponentRefDirective,
    HtmlEditorComponentRefDirective,
    InputGroupComponentRefDirective,
    DatepickerComponentRefDirective,
    TimePickerComponentRefDirective,
    NumberSpinnerComponentRefDirective,
    ComboListComponentRefDirective,
    ComboLookupComponentRefDirective,
    LookupGridComponentRefDirective,
    DatagridComponentRefDirective,
    TreetableComponentRefDirective,
    WizardComponentRefDirective,
    DiscussionEditorComponentRefDirective,
    DiscussionListComponentRefDirective,
    NavComponentRefDirective,
    MultiSelectComponentRefDirective,
    ScrollspyComponentRefDirective,
    ComboLookupDataMappingDirective,
    AppointmentCalendarBindingDirective,
    CustomDatagridSizeDirective,
    FarrisFilterBindingDirective,
    FarrisListFilterBindingDirective,
    PortletFilterBindingDirective,
    ElementReadonlyPipe,
    ElementVisibilityPipe,
    ElementRequiredPipe,
    ToolbarUsabilityPipe,
    ToolbarVisibilityPipe,
    ButtonUsabilityPipe,
    ButtonVisibilityPipe,
    AttachmentUploadVisiblePipe,
    AttachmentUploadDisabledPipe,
    AttachmentPreviewVisiblePipe,
    AttachmentPreviewReadonlyPipe,
    AttachmentDisabledPipe,
    AttachmentNoDownloadPipe,
    AttachmentNoPreviewPipe,
    AttachmentPreviewShowCommentsPipe,
    AttachmentPreviewEnableEditFilePipe,
    AttachmentNoDeletePipe, 
  ],
  providers: [
    DialogService, GridComponent, FarrisKendoGridFormatService, FarrisTreetableFormatService],
  exports: [
    KendoGridBindingDirective,
    FarrisTreeTableBindingDirective,
    LookupDataMappingDirective,
    LookupEnableExtendLoadMethodDirective,
    UIStateBindingDirective,
    FarrisDisabledDirective,
    FarrisSortDirective,
    FarrisDynamicColumnFormatDirective,
    FarrisEditEnterDirective,
    FarrisTextareaEditDirective,
    FarrisTreeTableFormatDirective,
    StringToDatePipe,
    GridColumnAggregateDirective,
    DateFormatPlaceholderPipe,
    ImageIdToUrlPipe,
    FormatPrimeNgTreeTableCellData,
    FarrisDatagridUseBindingDataDirective,
    MultiSelectDataMappingDirective,
    FarrisListViewBindingDirective,
    EditableDirective,
    KendoGridFilterDirective,
    FormatTotalPipe,
    InputEndEditDirective,
    FarrisDataGridEndEditDirective,
    HtmlEditorEndEditDirective,
    KendoGridEndEditDirective,
    FarrisDataGridRemoteSummaryDirective,
    FarrisFilePreviewBindingDirective,
    FarrisSetFocusDirective,
    FarrisDiscussionEditorBindingDirective,
    FarrisDiscussionListBindingDirective,
    FarrisPrimengTreeTableBindingDirective,
    FarrisDynamicRequiredDirective,
    FarrisEditorDirective,
    FarrisQuerySolutionEventBindDirective,
    FarrisDateLocalizationDirective,
    FarrisNumberLocalizationDirective,
    FarrisTimeLocalizationDirective,
    FarrisTextLocalizationDirective,
    Localization,
    FarrisCheckboxModificationDirective,
    FarrisLabelModificationDirective,
    FarrisLookupBindingDirective,
    ListNavComponentRefDirective,
    ListViewComponentRefDirective,
    ListFilterComponentRefDirective,
    ViewChangeComponentRefDirective,
    FilterComponentRefDirective,
    SectionComponentRefDirective,
    HtmlEditorComponentRefDirective,
    InputGroupComponentRefDirective,
    DatepickerComponentRefDirective,
    TimePickerComponentRefDirective,
    NumberSpinnerComponentRefDirective,
    ComboListComponentRefDirective,
    ComboLookupComponentRefDirective,
    LookupGridComponentRefDirective,
    DatagridComponentRefDirective,
    TreetableComponentRefDirective,
    WizardComponentRefDirective,
    DiscussionEditorComponentRefDirective,
    DiscussionListComponentRefDirective,
    NavComponentRefDirective,
    MultiSelectComponentRefDirective,
    ScrollspyComponentRefDirective,
    ComboLookupDataMappingDirective,
    AppointmentCalendarBindingDirective,
    CustomDatagridSizeDirective,
    ElementReadonlyPipe,
    ElementVisibilityPipe,
    ElementRequiredPipe,
    ToolbarUsabilityPipe,
    ToolbarVisibilityPipe,
    FarrisFilterBindingDirective,
    FarrisListFilterBindingDirective,
    PortletFilterBindingDirective,
    ButtonUsabilityPipe,
    ButtonVisibilityPipe,
    AttachmentUploadVisiblePipe,
    AttachmentUploadDisabledPipe,
    AttachmentPreviewVisiblePipe,
    AttachmentPreviewReadonlyPipe,
    AttachmentDisabledPipe,
    AttachmentNoDownloadPipe,
    AttachmentNoPreviewPipe,
    AttachmentPreviewShowCommentsPipe,
    AttachmentPreviewEnableEditFilePipe,
    AttachmentNoDeletePipe,
  ]
})
class KendoBindingModule {
}

export { KendoBindingModule };
